import apiClient from './apiClient';

// ============================================================
// Types — matching backend Go models
// ============================================================

export interface F911 {
  f911_01: string;   // Employee code
  f911_02: string | null; // Punch date (ISO)
  f911_03: string;   // Punch time (HH:MM:SS)
  f911_11: string;   // Log code (Q/S/T/V)
  f911_12: string;   // Shift code
  f911_13: string;   // Raw card value
}

export interface F910 {
  f910_01: string;   // Employee code
  f910_02: string | null; // Date (ISO)
  f910_13: string;   // Card value
  f910_15: string;   // Shift code
  f910_21: string;   // Clock-in time
  f910_22: string;   // Clock-out time
  f910_23: string;   // Overtime clock time
  f910_29: number;   // Late minutes
  f910_30: number;   // Early-leave minutes
  f910_31: string;   // Department code
  f910_32: string;   // Expected start time
  f910_33: string;   // Expected end time
  f910_34: string;   // Last punch mode
  f910_35: string;   // Last punch time
  f910_251: string;  // Out time 1
  f910_252: string;  // Out time 2
  f910_253: string;  // Out time 3
  f910_254: string;  // Out time 4
  f910_255: string;  // Out time 5
  f910_261: string;  // Return time 1
  f910_262: string;  // Return time 2
  f910_263: string;  // Return time 3
  f910_264: string;  // Return time 4
  f910_265: string;  // Return time 5
}

export interface PunchRequest {
  card_value: string;
  log_code: string; // Q/S/T/V
}

export interface PunchResponse {
  employee_code: string;
  employee_name: string;
  log_code: string;
  punch_time: string;
  punch_date: string;
  late_minutes: number;
  early_minutes: number;
  message: string;
}

export interface ListResponse<T> {
  data: T[];
  total: number;
  page: number;
  size: number;
}

// ============================================================
// API client
// ============================================================

const PREFIX = '/api/pw9220';

export const pw9220Api = {
  // Clock in/out punch
  async punch(req: PunchRequest): Promise<PunchResponse> {
    const res = await apiClient.post(`${PREFIX}/punch`, req);
    return res.data;
  },

  // List attendance records
  async listAttendance(params: {
    employee_code?: string;
    date?: string;
    date_from?: string;
    date_to?: string;
    page?: number;
    size?: number;
  } = {}): Promise<ListResponse<F910>> {
    const res = await apiClient.get(`${PREFIX}/attendance`, { params });
    return res.data;
  },

  // List punch log entries
  async listPunchLogs(params: {
    employee_code?: string;
    date?: string;
    date_from?: string;
    date_to?: string;
    page?: number;
    size?: number;
  } = {}): Promise<ListResponse<F911>> {
    const res = await apiClient.get(`${PREFIX}/punch-logs`, { params });
    return res.data;
  },
};

export default pw9220Api;
